import { registerDecorators as _registerDecorators, registerComponent as _registerComponent, LightningElement } from "lwc";
import _tmpl from "./securityStep1Welcome.html";
import { WireStore } from '@oneappexchange/lwc-wired';
import { DateTime } from 'luxon';
import { getVersionsByPackageId } from '~/modules/services/packagesService';
import { WireI18n } from '~/modules/stores/i18nStore';
import { securityReviewStore, selectFalsePositiveInFailedSR, selectOpsAttemptsCount, selectOpsFeedback, selectSecurityReview, selectSolution } from '~/modules/stores/securityReviewStore';
import { formatDate } from '~/modules/utilities/dateUtilities';
import { OpsSecurityOpsReviewStatus, PartnerSecurityReviewStatus, getStateForProgressIndicatorFinalStep, getStateForProgressIndicatorProdSecReview, getStateForProgressIndicatorReceivedProcessing, getStateForProgressIndicatorSubmitReview, lastChallengeRaised } from '~/modules/utilities/securityReviewUtilities';
import { getPlugin } from '~/modules/utilities/securityReviewValidatorUtilities';
export let TYPE_STATUS_STEP_SR = /*#__PURE__*/function (TYPE_STATUS_STEP_SR) {
  TYPE_STATUS_STEP_SR["info"] = "info";
  TYPE_STATUS_STEP_SR["success"] = "success";
  TYPE_STATUS_STEP_SR["error"] = "error";
  TYPE_STATUS_STEP_SR["blank"] = "blank";
  TYPE_STATUS_STEP_SR["warning"] = "warning";
  return TYPE_STATUS_STEP_SR;
}({});
class SecurityStep1Welcome extends LightningElement {
  constructor(...args) {
    super(...args);
    this.steps = [];
    this.docs = [{
      title: '',
      text: ''
    }, {
      title: '',
      text: ''
    }, {
      title: '',
      text: ''
    }, {
      title: '',
      text: ''
    }];
    this.securityReview = void 0;
    this.securityFeedbackItems = void 0;
    this.attemptsCount = void 0;
    this.solutionTechnology = void 0;
    this.labels = {};
    this.sharedLabels = {};
    this.solution = void 0;
    this.hasFalsePositiveDocument = false;
    this.show2GPWarning = false;
  }
  async securityReviewStoreConnected(state) {
    var _this$solution, _this$solution$soluti;
    this.securityReview = selectSecurityReview(state);
    this.securityFeedbackItems = selectOpsFeedback(state);
    this.solution = selectSolution(state);
    this.attemptsCount = selectOpsAttemptsCount(state);
    this.solutionTechnology = this.solution.technology;
    this.updateIndicator();
    this.hasFalsePositiveDocument = Boolean(selectFalsePositiveInFailedSR(state).mediaId);
    const packageCategory = (_this$solution = this.solution) === null || _this$solution === void 0 ? void 0 : (_this$solution$soluti = _this$solution.solution) === null || _this$solution$soluti === void 0 ? void 0 : _this$solution$soluti.packageCategory;
    let hasPackageVersionSecurityReviewed = false;
    if (this.solution.solution) {
      hasPackageVersionSecurityReviewed = await this.hasPackageVersionSecurityReviewed(this.solution.solution.packageId);
    }
    this.show2GPWarning = (packageCategory === 'Unmanaged' || packageCategory === 'Managed') && !hasPackageVersionSecurityReviewed;
  }
  i18nCallback(i18n) {
    this.labels = i18n.srwStep1Welcome;
    this.sharedLabels = i18n.shared;
    this.docs[0] = {
      title: this.labels.docTitle1,
      text: this.labels.docDescription1
    };
    this.docs[1] = {
      title: this.labels.docTitle2,
      text: this.labels.docDescription2
    };
    this.docs[2] = {
      title: this.labels.docTitle3,
      text: this.labels.docDescription3
    };
    this.docs[3] = {
      title: this.labels.docTitle4,
      text: this.labels.docDescription4
    };
    this.updateIndicator();
  }
  dismiss2GPWarning() {
    this.show2GPWarning = false;
  }
  get partnerReviewStatus() {
    var _this$securityReview;
    return (_this$securityReview = this.securityReview) === null || _this$securityReview === void 0 ? void 0 : _this$securityReview.status;
  }
  get opsReviewStatus() {
    return securityReviewStore.getState().securityReviewOps.status;
  }
  get isSubmitted() {
    var _this$securityReview2, _this$securityReview3;
    return ((_this$securityReview2 = this.securityReview) === null || _this$securityReview2 === void 0 ? void 0 : _this$securityReview2.status) === PartnerSecurityReviewStatus.submitted || ((_this$securityReview3 = this.securityReview) === null || _this$securityReview3 === void 0 ? void 0 : _this$securityReview3.status) === PartnerSecurityReviewStatus.reSubmitted;
  }
  get showDiggingIntoDetials() {
    var _this$securityReview4;
    return ((_this$securityReview4 = this.securityReview) === null || _this$securityReview4 === void 0 ? void 0 : _this$securityReview4.status) === PartnerSecurityReviewStatus.new;
  }
  get securityReviewDate() {
    var _this$securityReview5, _this$securityReview6, _this$securityReview$, _this$securityReview7;
    if (((_this$securityReview5 = this.securityReview) === null || _this$securityReview5 === void 0 ? void 0 : _this$securityReview5.status) === PartnerSecurityReviewStatus.submitted || ((_this$securityReview6 = this.securityReview) === null || _this$securityReview6 === void 0 ? void 0 : _this$securityReview6.status) === PartnerSecurityReviewStatus.reSubmitted) {
      if (this.opsReviewStatus === OpsSecurityOpsReviewStatus.failedTest || this.opsReviewStatus === OpsSecurityOpsReviewStatus.returnedOps || this.opsReviewStatus === OpsSecurityOpsReviewStatus.returnedProdSec || this.opsReviewStatus === OpsSecurityOpsReviewStatus.expired) {
        var _this$lastFeedbackIte;
        return formatDate((_this$lastFeedbackIte = this.lastFeedbackItem) === null || _this$lastFeedbackIte === void 0 ? void 0 : _this$lastFeedbackIte.date);
      } else if (this.opsReviewStatus === OpsSecurityOpsReviewStatus.pass) {
        return formatDate(securityReviewStore.getState().securityReviewOps.approvalDate);
      }
    }
    return formatDate((_this$securityReview$ = (_this$securityReview7 = this.securityReview) === null || _this$securityReview7 === void 0 ? void 0 : _this$securityReview7.user_updated_at) !== null && _this$securityReview$ !== void 0 ? _this$securityReview$ : DateTime.now());
  }
  get submitCount() {
    return this.attemptsCount;
  }
  get lastFeedbackItem() {
    var _this$securityFeedbac;
    return (_this$securityFeedbac = this.securityFeedbackItems) === null || _this$securityFeedbac === void 0 ? void 0 : _this$securityFeedbac.items.sort((a, b) => {
      const aTime = DateTime.fromISO(a.date);
      const bTime = DateTime.fromISO(b.date);
      if (aTime.toMillis() === bTime.toMillis()) {
        return 0;
      }
      return aTime > bTime ? -1 : 1;
    })[0];
  }
  get lastChallengeRaised() {
    return lastChallengeRaised(this.securityReview);
  }
  get challengeRaised() {
    const raiseAChallenge = getPlugin(this.securityReview, 'securityReview/plugins/RaiseAChallenge');
    if (raiseAChallenge && raiseAChallenge.challengeRaised) {
      return raiseAChallenge.challengeRaised;
    }
    return false;
  }
  get partnerWaitingReason() {
    const securityReviewOps = securityReviewStore.getState().securityReviewOps;
    return securityReviewOps.partnerWaitingReason;
  }
  updateIndicator() {
    const securityReviewOps = securityReviewStore.getState().securityReviewOps;
    if (this.labels && this.securityReview) {
      this.steps = [getStateForProgressIndicatorSubmitReview(this.securityReview, securityReviewOps, this.labels), getStateForProgressIndicatorReceivedProcessing(this.securityReview, securityReviewOps, this.labels), getStateForProgressIndicatorProdSecReview(this.securityReview, securityReviewOps, this.labels), getStateForProgressIndicatorFinalStep(this.securityReview, securityReviewOps, this.labels)];
    }
  }
  async hasPackageVersionSecurityReviewed(packageId) {
    if (packageId) {
      const versionsData = await getVersionsByPackageId(packageId);
      for (const version of versionsData) {
        if (version.versionOptionsSecurityReviewed) {
          return true;
        }
      }
    }
    return false;
  }
  /*LWC compiler v7.1.3*/
}
_registerDecorators(SecurityStep1Welcome, {
  track: {
    steps: 1
  },
  wire: {
    securityReviewStoreConnected: {
      adapter: WireStore,
      dynamic: [],
      method: 1,
      config: function ($cmp) {
        return {
          store: securityReviewStore
        };
      }
    },
    i18nCallback: {
      adapter: WireI18n,
      method: 1,
      config: function ($cmp) {
        return {};
      }
    }
  },
  fields: ["docs", "securityReview", "securityFeedbackItems", "attemptsCount", "solutionTechnology", "labels", "sharedLabels", "solution", "hasFalsePositiveDocument", "show2GPWarning"]
});
const __lwc_component_class_internal = _registerComponent(SecurityStep1Welcome, {
  tmpl: _tmpl,
  sel: "appx-security-step1welcome",
  apiVersion: 62
});
export default __lwc_component_class_internal;